import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import React, { useEffect, useState, useRef } from 'react';
import EmptyState from '../../../../Components/EmptyState';
import { Spinner } from '../../../../Components/Spinner/Spinner';
import Dropdown from '../../../../Components/Dropdown';
import {ProductRequestResult, ProductRequestResultProduct} from '../../../../Services/SearchProductFeedTypes';
import { Listbox, ListboxItem } from '../../../../Components/Listbox/Listbox';

export const AutocompleteProductIds = ({
	needTenantForSearch,
	searchProductFeed,
	selectedTenant,
	handleSelectidOfProduct,
}) => {

	const refInput = useRef<HTMLInputElement>(null);
	const [searchValue, setSearchValue] = useState('');
	const [hasSearch, setHasSearch] = useState(false);
	const [focused, setFocused] = useState(false);
	const [list, setList] = useState<React.ReactNode>(<></>);
	const [isLoading, setIsLoading] = useState(true);
	const [datas, setDatas] = useState<ProductRequestResultProduct[]>([]);
	const [noData, setNoData] = useState(true);

	function sortArrayProducts(a, b) {
		if (a.id < b.id) return -1;
		if (a.id > b.id) return 1;
		return 0;
	}

	function ListItemProductId({ id, label, imageUrl, onClick }) {
		return (
			<ListboxItem onClick={onClick}>
				<div className='flex'>
					<div className='flex_item_fix'>
						<ProductThumb url={imageUrl} width={40} />
					</div>
					<div className='flex_item_full'>
						<div>{label}</div>
						<div className='s_13 grey_3 mt_3'>{id}</div>
					</div>
				</div>
			</ListboxItem>
		);
	}

	useEffect(() => {
		const formattedList: any = datas.map((product: any) => (
			<ListItemProductId
				key={product.id}
				id={product.id}
				imageUrl={product.urlThumbnail}
				label={product.name}
				onClick={() => handleSelectidOfProductAndFilter(product)}
			/>
		));
		setList(formattedList);
	}, [datas]);

	const getListOfSpecificities = () => {
		if (!needTenantForSearch) {
			setIsLoading(true);
			searchProductFeed.postSearchEmptyTenant(
				{
					searchTerm: searchValue,
					requestedFields: ['NameAndThumbnail'],
					limit: 40,
				},
				(data: ProductRequestResult) => {
					setIsLoading(false);
					setDatas([...data.products.sort(sortArrayProducts)]);
					setNoData(data.products.length === 0);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
				}
			);
		} else {
			setIsLoading(true);
			searchProductFeed.postSearchWithTenant(
				{
					searchTerm: searchValue,
					requestedFields: ['NameAndThumbnail'],
					limit: 40,
				},
				selectedTenant,
				(data:ProductRequestResult) => {
					setDatas([...data.products.sort(sortArrayProducts)]);
					setIsLoading(false);
					setNoData(data.products.length === 0);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
					setIsLoading(false);
				}
			);
		}
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			if (searchValue && searchValue.length !== 0) {
				getListOfSpecificities();
			}
			setHasSearch(searchValue.length > 0);
		}, 800);

		return () => {
			clearTimeout(timer);
		};
	}, [searchValue]);

	useEffect(() => {
		if (focused && refInput) {
			document.addEventListener('click', handleClickOutside);
			return () => {
				document.removeEventListener('click', handleClickOutside);
			};
		}
	}, [refInput, focused]);

	function handleClickOutside(event) {
		if (!event) return;
		if (refInput.current && !refInput.current.contains(event.target)) {
			event.stopPropagation();
			setFocused(false);
			resetAutocomplete();
		}
	}

	const handleSelectidOfProductAndFilter = (product:ProductRequestResultProduct) => {
		setDatas((prevDatas) => prevDatas.filter((p) => p.id !== product.id));
		handleSelectidOfProduct(product);
		resetAutocomplete();
	};

	const resetAutocomplete = () => {
		setList(<></>);
		setSearchValue('');
		setHasSearch(false);
		setNoData(true);
	};

	return (
		<>
			<div className="custom_input w_full">
				<i className="fas fa-search custom_input_icon_before"></i>
				<input
					ref={refInput}
					autoComplete={'off'}
					placeholder={'Search for a product'}
					onFocus={() => setFocused(true)}
					type="text"
					value={searchValue}
					onChange={ e => setSearchValue(e.target.value)}
				/>
			</div>
			{hasSearch &&
				<Dropdown isOpen={true} buttonRef={refInput} scrollbar={true} minWidth={300}>
					{isLoading &&
						<Spinner size="l" display={noData ? 'block'  :  'overlay'} />
					}
					{!isLoading && noData &&
						<EmptyState
							title='No matching product'
							text='Please try with another search'
						/>
					}
					{list &&
						<Listbox>{list}</Listbox>
					}
				</Dropdown>
			}
		</>
	);
};